import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import EmployeesPage from "@/pages/EmployeesPage";
import AssetsPage from "@/pages/AssetsPage";
import AssignmentsPage from "@/pages/AssignmentsPage";
import SIMConnectionsPage from "@/pages/SIMConnectionsPage";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import Layout from "@/components/Layout";
import EmployeeLayout from "@/components/EmployeeLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { getUserRole } from "@/lib/auth";

function App() {
  const role = getUserRole();

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          
          {/* HR/Admin Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute allowedRoles={["HR", "Admin"]}>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="employees" element={<EmployeesPage />} />
            <Route path="assets" element={<AssetsPage />} />
            <Route path="assignments" element={<AssignmentsPage />} />
            <Route path="sim-connections" element={<SIMConnectionsPage />} />
          </Route>

          {/* Employee Routes */}
          <Route
            path="/employee"
            element={
              <ProtectedRoute allowedRoles={["Employee"]}>
                <EmployeeLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<EmployeeDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;